import React, {FC, useCallback} from "react";

import {Button} from "../../elements/Button/Button";

import style from './header.module.scss';

import BrilliantIcon from '../../assets/img/icons/brilliant-icon.svg'
import BrilliantIconSnow from '../../assets/img/icons/brilliat-icon-snow.svg'
import PlusIcon from '../../assets/img/icons/plus-icon.svg'
import PlusIconSnow from '../../assets/img/icons/plus-icon-snow.svg'
import BurgerIcon from '../../assets/img/icons/burger-icon.svg'
import {useIsMobile} from "../../hooks/useIsMobile";
import {setShowMenu, useMenuSelector} from "../../redux/slices/menu";
import {useAppDispatch} from "../../redux/store";
import {useIsDarkTheme} from "../../hooks/useGetTheme";

export const Header:FC = () =>
{
    const dispatch = useAppDispatch();

    const isMobile = useIsMobile();
    const isDark = useIsDarkTheme();
    const { show: showMenu } = useMenuSelector();

    const handleMenuOpen = useCallback(() => dispatch(setShowMenu(!showMenu)), [dispatch, showMenu]);

    const pi = isDark ? PlusIconSnow : PlusIcon;
    const bi = isDark ? BrilliantIconSnow : BrilliantIcon;

    return (
        <header className={style.header}>
            <div className={style.buttons}>
                <Button
                    label="Add to server"
                    name="add-to-server"
                    icon={isMobile ? pi : undefined}
                    rounded={isMobile}
                    href={'https://discord.com/api/oauth2/authorize?client_id=620689014910877719&scope=bot&permissions=8'}
                />
                {isMobile && (
                    <Button
                        label="Open Menu"
                        name="open-menu"
                        icon={BurgerIcon}
                        transparent
                        rounded
                        onClick={handleMenuOpen}
                    />
                )}
                <Button
                    label="Get premium"
                    name="get-premium"
                    href={'https://patreon.com/vrb'}
                    icon={bi}
                    rounded={isMobile}
                />
            </div>
        </header>
    );
}
